import axios from "axios";
import Cookies from "js-cookie";
import { ACCESS_TOKEN_COOKIE } from "../auth/tokenHelpers";
import { attachAuthInterceptors } from "../auth/authInterceptor";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * Auth header matches buyer's `makeApiCall`: send the RAW cookie value
 * (the JSON-stringified token object) as Authorization — NOT `Bearer x`.
 * The gateway expects this exact format.
 */
api.interceptors.request.use((config) => {
  const raw = Cookies.get(ACCESS_TOKEN_COOKIE);
  if (raw) {
    config.headers = config.headers ?? {};
    config.headers["Authorization"] = raw;
  }
  // FormData → let browser set multipart boundary
  if (config.data instanceof FormData) {
    config.headers = config.headers ?? {};
    delete (config.headers as any)["Content-Type"];
  }
  return config;
});

// 401 → single-flight refresh → retry; only a dead refresh token ends the
// session (graceful modal + /login). rejectWith 'error': shell callers use
// plain axios try/catch semantics.
attachAuthInterceptors(api, { rejectWith: "error" });

export default api;
